import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleClick = this._handleClick.bind(this);
  }

  static propTypes = {
    'pageChange': PropTypes.func,
    'meta.current_page': PropTypes.number,
    'meta.total': PropTypes.number,
    'meta.last_page': PropTypes.number,
    'meta.from': PropTypes.number,
    'meta.to': PropTypes.number,
    'meta': PropTypes.object.isRequired,
    'name': PropTypes.string,
    'pageSizeChange': PropTypes.func,
  };

  _handleClick(e) {
    e.preventDefault();
    const pageNumber = e.target.getAttribute('href');
    this.props.pageChange(pageNumber);
  }

  render() {
    const { meta, pageSizeChange, name } = this.props;
    const { current_page, total, last_page, from, to, per_page } = meta;

    return (
      <div className="row align-items-center">
        <div className="col col-sm-auto">
          <Trans>
            Showing {{ from }} to {{ to }} of
          </Trans>{' '}
          <strong>
            {total} {name}
          </strong>
        </div>
        <div className="col">
          <div className="form-inline">
            {per_page && (
              <select
                name=""
                id=""
                className="form-control m-input"
                defaultValue={per_page}
                onChange={(e) => pageSizeChange(e.target.value)}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            )}
          </div>
        </div>
        <div className="col col-sm-auto">
          <ul className="pagination">
            <li className={'page-item' + (current_page > 1 ? ' ' : ' disabled')}>
              <a onClick={this._handleClick} className="page-link" href={1} tabIndex="-1">
                <Trans>First</Trans>
              </a>
            </li>
            <li className={'page-item' + (current_page > 1 ? ' ' : ' disabled')}>
              <a
                onClick={this._handleClick}
                className="page-link"
                href={current_page > 1 ? current_page - 1 : ''}
                tabIndex="-1"
              >
                <Trans>Previous</Trans>
              </a>
            </li>
            {current_page > 3 && (
              <li className="page-item disabled">
                <a onClick={this._handleClick} className="page-link" href="#">
                  ...
                </a>
              </li>
            )}
            {current_page > 2 && (
              <li className="page-item">
                <a onClick={this._handleClick} className="page-link" href={current_page - 2}>
                  {current_page - 2}
                </a>
              </li>
            )}
            {current_page > 1 && (
              <li className="page-item">
                <a onClick={this._handleClick} className="page-link" href={current_page - 1}>
                  {current_page - 1}
                </a>
              </li>
            )}
            <li className="page-item active">
              <a className="page-link" href="#">
                {current_page} <span className="sr-only">(current)</span>
              </a>
            </li>
            {current_page < last_page && (
              <li className="page-item">
                <a onClick={this._handleClick} className="page-link" href={current_page + 1}>
                  {current_page + 1}
                </a>
              </li>
            )}
            {current_page < last_page - 1 && (
              <li className="page-item">
                <a onClick={this._handleClick} className="page-link" href={current_page + 2}>
                  {current_page + 2}
                </a>
              </li>
            )}
            {current_page < last_page - 2 && (
              <li className="page-item disabled">
                <a onClick={this._handleClick} className="page-link" href="#">
                  ...
                </a>
              </li>
            )}

            <li className={'page-item' + (current_page === last_page ? ' disabled' : '')}>
              <a
                onClick={this._handleClick}
                className="page-link"
                href={current_page === last_page ? '' : current_page + 1}
              >
                <Trans>Next</Trans>
              </a>
            </li>
            <li className={'page-item' + (current_page === last_page ? ' disabled' : '')}>
              <a onClick={this._handleClick} className="page-link" href={last_page} tabIndex="-1">
                <Trans>Last</Trans>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Pagination;
